(ns bp-clients.tv-app.core
  "Tv client core namespace.
  This is called on application startup."
  (:require
   ["spatial-navigation"]
   ["webos-api"]
   [bp-clients.tv-app.auth.events :as auth-events]
   [bp-clients.tv-app.common.components.splash :refer [splash]]
   [bp-clients.tv-app.common.events :as common-events]
   [bp-clients.tv-app.db :as db]
   [bp-clients.tv-app.nav.events :as nav-events]
   [bp-clients.tv-app.nav.subs :as nav-subs]
   [bp-clients.tv-app.nav.views.nav :refer [nav]]
   [bp-clients.tv-app.nav.views.paywall :refer [paywall]]
   [bp-clients.tv-app.pages.page-list :refer [page-list]]
   [bp-clients.tv-app.pages.playlist :refer [playlist]]
   [bp-clients.tv-app.pages.search :refer [search]]
   [bp-clients.tv-app.utils.logger :as logger]
   [bp-clients.tv-app.utils.os :as os-system]
   [bp-clients.tv-app.utils.stats :as stats]
   [clojure.string :as str]
   [goog.events :as events]
   [re-frame.core :as rf]
   [reagent.dom :as r])
  (:import [goog.events EventType]))

(goog-define skip-splash? false)
(goog-define show-fps?    false)

(defn pages
  [page-name]
  (let [paywall-data @(rf/subscribe [::nav-subs/paywall])]
    (case page-name
      :search                         [search]
      (:page-index :login :page-list) [page-list]
      :upgrade                        [paywall paywall-data]
      :playlist                       [playlist]

      "not found")))

(defn app
  []
  (let [active-nav      @(rf/subscribe [::nav-subs/active-nav])
        active-page     @(rf/subscribe [::nav-subs/active-page])
        active-playlist @(rf/subscribe [::nav-subs/active-playlist])
        splash-played?  @(rf/subscribe [::nav-subs/splash-ended?])
        loaded-db?      @(rf/subscribe [::db/loaded-db?])]
    (when loaded-db?
      (when (= "webos" os-system/device)
        (.deviceInfo js/webOS (fn [device]
                                (logger/set-device-info! {:model-name (.-modelName device)
                                                          :screen-width (.-screenWidth device)
                                                          :screen-height (.-screenHeight device)
                                                          :is-oled? (.-oled device)
                                                          :uhd? (.-uhd device)}))))
      (logger/set-context! (->> [active-page active-nav active-playlist]
                                (filter (comp not nil?))
                                (mapv name)
                                (str/join "/")))

      (cond
        (not (or splash-played? skip-splash?))
        [splash {:on-end #(rf/dispatch [::nav-events/splash-playback])}]

        :else
        [:<> {:key (str active-page active-nav active-playlist)}
         [nav [pages active-page]]]))))

(defn init-navigation
  []
  (.init js/SpatialNavigation)
  (.add js/SpatialNavigation "overlay"
        (clj->js {:selector                "*[tabindex=\"40\"]"
                  :rememberSource          true
                  :straightOnly            true
                  :straighOverlapThreshold 0.3}))
  (.add js/SpatialNavigation "player-side"
        (clj->js {:selector                "*[tabindex=\"30\"]"
                  :rememberSource          true
                  :straightOnly            true
                  :straighOverlapThreshold 0.3}))

  (.add js/SpatialNavigation "menu"
        (clj->js {:selector                "*[tabindex=\"20\"]"
                  :rememberSource          true
                  :straightOnly            true
                  :straighOverlapThreshold 0.3}))

  (.add js/SpatialNavigation "content"
        (clj->js {:selector                "*[tabindex=\"10\"]"
                  :rememberSource          true
                  :straighOverlapThreshold 0.3}))
  (.focus js/SpatialNavigation "content"))

(defn setup-core-event-listeners! []
  (events/listen js/window EventType/LOAD init-navigation)
  (events/listen js/window EventType/ONLINE #(do (rf/dispatch [::common-events/process-error-queue])
                                                 (rf/dispatch [::nav-events/network-online])))
  (events/listen js/window EventType/OFFLINE #(rf/dispatch [::nav-events/network-offline])))

(defn ^:dev/after-load start
  []
  (setup-core-event-listeners!)
  (r/render [app]
            (.getElementById js/document "app")))

(defn ^:export init
  []
  (when show-fps? (stats/add-fps-panel))
  (rf/dispatch-sync [::common-events/init-indexdb [::auth-events/pre-init-db ::db/initialize-db]])
  (start))
